import { ENTITLEMENTS_QUERY_KEY } from '../entitlements';
import type { NotificationCategory, NotificationMessage } from './notificationMessage';

/**
 * Category → React Query key roots. Prefix matching (default invalidateQueries) refreshes
 * every query whose key starts with the root — do not pass `exact: true`.
 */
const ROOTS_BY_CATEGORY: Record<NotificationCategory, string[][]> = {
  Trade: [['deals'], ['holdings'], ['cash-ledger'], ['analytics']],
  MarketData: [['prices'], ['holdings'], ['analytics']],
  ReferenceData: [['instruments'], ['accounts'], ['portfolios'], ['custodians']],
  CorporateAction: [['deals'], ['holdings'], ['analytics']],
  Ownership: [['clients'], ['portfolios']],
  PrivateEquity: [['private-equity'], ['holdings']],
  Compliance: [['compliance-dashboard'], ['compliance-rules'], ['compliance-policies']],
  General: [],
};

const ENTITLEMENTS_EVENT = 'TenantEntitlementsChanged';

/** Resolves de-duplicated query key roots for a flushed notification batch. */
export function queryKeysForNotifications(batch: NotificationMessage[]): string[][] {
  const seen = new Set<string>();
  const roots: string[][] = [];

  for (const notification of batch) {
    if (notification.eventType === ENTITLEMENTS_EVENT) {
      addRoot(roots, seen, [...ENTITLEMENTS_QUERY_KEY]);
    }

    const categoryRoots = ROOTS_BY_CATEGORY[notification.category] ?? [];
    for (const root of categoryRoots) {
      addRoot(roots, seen, root);
    }
  }

  return roots;
}

function addRoot(roots: string[][], seen: Set<string>, root: string[]): void {
  const key = root.join('\0');
  if (seen.has(key)) return;
  seen.add(key);
  roots.push(root);
}
